/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Cancel_ButtonInputs */



/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Event_Notes_Cancel_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_cancel_button = /** @type {((inputs?: Event_Notes_Cancel_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Cancel_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stornieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancellare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отмена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("取消")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャンセル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रद्द करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancelar")
	return /** @type {LocalizedString} */ ("Cancel")
});